import {
  getLiquidwebPlanLinks,
  getPlanSafeHarborLinks as getPlanSafeHarborLinksLeatherman,
  getPlanSafeHarborStagingEnvironmentLinks as getPlanSafeHarborStagingEnvironmentLinksLeatherman,
} from "leatherman-js/utils/nav/plan";
import { getNexcessBillingLinks, getThermoBillingLinks } from "leatherman-js/utils/nav/billing";
import { getNexcessDNSLinks, getThermoDNSLinks } from "leatherman-js/utils/nav/dns";
import { getNexcessMainLinks, getThermoMainLinks } from "leatherman-js/utils/nav/main";
import {
  getSharedHostLinks as getSharedHostLinksLeatherman,
  getSharedHostSafeHarborLinks as getSharedHostSafeHarborLinksLeatherman,
  getSharedHostSafeHarborStagingEnvironmentLinks as getSharedHostSafeHarborStagingEnvironmentLinksLeatherman,
} from "leatherman-js/utils/nav/sharedHost";
import constants from "@/utils/constants";
import { getLiquidwebDevSiteLinks } from "leatherman-js/utils/nav/devSite";
import { getLiquidwebSiteLinks } from "leatherman-js/utils/nav/site";
import { getPartnerLinks as getPartnerLinksLeatherman } from "leatherman-js/utils/nav/partner";
import { getSettingsLinks as getSettingsLinksLeatherman } from "leatherman-js/utils/nav/settings";
import { getTShirtDevSiteLinks } from "leatherman-js/utils/nav/devSite";
import { getTShirtPlanLinks } from "leatherman-js/utils/nav/plan";
import { getTShirtSiteLinks } from "leatherman-js/utils/nav/site";
import i18n from "@/i18n";
import NavLink from "@/classes/NavLink";

export function home() {
  return new NavLink("Home", "home", constants.HOME_ROUTE);
}

export function back(text, route = constants.HOME_ROUTE) {
  return new NavLink(text, "back", route);
}

export function domainList() {
  return new NavLink(i18n.t("global.domains"), null, "domains");
}

export function otherList() {
  return new NavLink(i18n.t("navigation.other-list"), null, "other");
}

export function profileInfo() {
  return new NavLink("My Profile", "settings", "profile");
}

export function profile2fa() {
  return new NavLink("2 Factor Auth", "ssl", "2fa");
}

export function planDetail(id, nickname) {
  return new NavLink(nickname, null, { name: "plan-detail", params: { planId: id } });
}

export function planList() {
  return new NavLink(i18n.t("navigation.plan-list"), null, "plan-list");
}

export function planSiteList() {
  return new NavLink(i18n.t("navigation.sites"), null, "plan-sites");
}

export function planSiteDetail(domain) {
  return new NavLink(domain, null, "plan-site-detail");
}

export function planDevSiteDetail(domain) {
  return new NavLink(domain, null, "plan-site-dev-detail");
}

export function planSiteDevEnvs(domain) {
  return new NavLink(domain, null, "plan-site-dev-environments");
}

export function getPlanSafeHarborLinks() {
  return createNavLinks(getPlanSafeHarborLinksLeatherman());
}

export function getPlanSafeHarborStagingEnvironmentLinks() {
  return createNavLinks(getPlanSafeHarborStagingEnvironmentLinksLeatherman());
}

export function planSafeHarbor(id) {
  return new NavLink(i18n.t("navigation.safe-harbor"), null, {
    name: "plan-safe-harbor",
    params: { id },
  });
}

export function planSafeHarborStagingEnvironments(id) {
  return new NavLink(i18n.t("navigation.staging-environments"), null, {
    name: "plan-safe-harbor-staging-environments",
    params: { id },
  });
}

export function planSafeHarborStagingEnvironment(planId, site) {
  return new NavLink(site.domain, null, {
    name: "plan-safe-harbor-staging-environment",
    params: { planId, stagingEnvironmentId: site.id },
  });
}

export function siteList() {
  return new NavLink(i18n.t("navigation.sites"), null, "plan-sites");
}

export function dnsZoneList() {
  return new NavLink(i18n.t("navigation.dns-zones"), null, "dns-zones");
}

export function rdnsRecordList() {
  return new NavLink(i18n.t("navigation.rdns-records"), null, "rdns-records");
}

export function invoiceList() {
  return new NavLink(i18n.t("navigation.invoices"), null, "invoices");
}

export function creditList() {
  return new NavLink(i18n.t("navigation.credits"), null, "credits");
}

export function paymentList() {
  return new NavLink(i18n.t("navigation.payments"), null, "payments");
}

export function orderList() {
  return new NavLink(i18n.t("navigation.orders"), null, "orders");
}

export function partnerLinkList() {
  return new NavLink(i18n.t("navigation.partner-links"), null, "partner-links");
}

export function partnerReferralList() {
  return new NavLink(i18n.t("navigation.partner-referrals"), null, "partner-referrals");
}

export function certificateList() {
  return new NavLink(i18n.t("navigation.ssl-certificates"), null, "certificates");
}

export function supportTicketList() {
  return new NavLink(i18n.t("navigation.support-tickets"), null, "tickets");
}

export function cloudServers() {
  return new NavLink(i18n.t("global.cloud-servers"), null, "cloud-servers");
}

export function createNavLinks(links) {
  return links.map((link) => {
    const linkName = i18n.t(`navigation.${link.name}`, link.meta);
    return new NavLink(
      linkName,
      link.icon,
      link.action || link.route,
      null,
      null,
      null,
      null,
      null,
      link.admin
    );
  });
}

export function getMainLinks(client, company, user) {
  let links = [];
  if (company === "thermo") {
    links = getThermoMainLinks(client, user);
  } else {
    links = getNexcessMainLinks(client, user);
  }
  return createNavLinks(links);
}

export function getPlanLinks(plan, user, client) {
  const links = plan.isTShirt
    ? getTShirtPlanLinks(user, plan)
    : getLiquidwebPlanLinks(user, client);
  return createNavLinks(links);
}

export function getSiteLinks(user, site, plan, isAdmin, isBeta) {
  let links = [];
  if (plan.isTShirt) {
    links = getTShirtSiteLinks(user, site, plan, isAdmin, isBeta);
  } else {
    links = getLiquidwebSiteLinks(user, site, plan, isAdmin);
  }
  return createNavLinks(links);
}

export function getDevSiteLinks(user, site, plan, isAdmin, isBeta) {
  let links = [];
  if (plan.isTShirt) {
    links = getTShirtDevSiteLinks(user, site, isAdmin, isBeta);
  } else {
    links = getLiquidwebDevSiteLinks(user, site, isAdmin);
  }
  return createNavLinks(links);
}

export function getBillingLinks(user, company) {
  let links = [];
  if (company === "thermo") {
    links = getThermoBillingLinks(user);
  } else {
    links = getNexcessBillingLinks(user);
  }
  return createNavLinks(links);
}

export function getDNSLinks(user, client, company) {
  let links = [];
  if (company === "thermo") {
    links = getThermoDNSLinks(user, client);
  } else {
    links = getNexcessDNSLinks(user, client);
  }
  return createNavLinks(links);
}

export function getPartnerLinks(client) {
  return createNavLinks(getPartnerLinksLeatherman(client));
}

export function getSettingsLinks(user) {
  const links = getSettingsLinksLeatherman(user);
  return createNavLinks(links);
}

export function getSharedHostLinks(sharedHost) {
  return createNavLinks(getSharedHostLinksLeatherman(sharedHost));
}

export function getSharedHostSafeHarborLinks() {
  return createNavLinks(getSharedHostSafeHarborLinksLeatherman());
}

export function getSharedHostSafeHarborStagingEnvironmentLinks() {
  return createNavLinks(getSharedHostSafeHarborStagingEnvironmentLinksLeatherman());
}

export function sharedHostDetail(id, domain) {
  return new NavLink(domain, null, { name: "shared-host", params: { id } });
}

export function sharedHostSafeHarbor(id) {
  return new NavLink(i18n.t("navigation.safe-harbor"), null, {
    name: "shared-host-safe-harbor",
    params: { id },
  });
}

export function sharedHostSafeHarborStagingEnvironments(id) {
  return new NavLink(i18n.t("navigation.staging-environments"), null, {
    name: "shared-host-safe-harbor-staging-environments",
    params: { id },
  });
}

export function sharedHostSafeHarborStagingEnvironment(sharedHostId, site) {
  return new NavLink(site.domain, null, {
    name: "shared-host-safe-harbor-staging-environment",
    params: { sharedHostId, stagingEnvironmentId: site.id },
  });
}

export function dedicatedList() {
  return new NavLink(i18n.t("navigation.dedicated-servers-empty"), null, "dedicated-servers");
}

export function coloList() {
  return new NavLink(i18n.t("navigation.colocations-empty"), null, "colocations");
}

export function resellerList() {
  return new NavLink(i18n.t("navigation.reseller-hosting-empty"), null, "reseller-hosting");
}
